"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.grayscaleStrategies = exports.imageToGrayscale = void 0;

var _RgbaImageBuffer = _interopRequireDefault(require("../RgbaImageBuffer"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Returns the given pixels converted to grayscale, according to the given
 * grayscale strategy
 *
 * @param {RgbaImageBuffer} imgBuffer Image Buffer base to create the grayscale
 * image from
 * @param {Function} grayscaleStrategy Method used to convert to grayscale.
 * Defaults to Phase Alternating Line
 * @returns {RgbaImageBuffer} Image buffer in grayscale
 */


var imageToGrayscale = function imageToGrayscale(imgBuffer) {
  var grayscaleStrategy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : pixelToGrayscalePal;
  var result = imgBuffer.copy();

  for (var i = 0; i < result.pixels.length; i += _RgbaImageBuffer.default.NUM_CHANNELS) {
    var rComponent = imgBuffer.pixels[i];
    var gComponent = imgBuffer.pixels[i + 1];
    var bComponent = imgBuffer.pixels[i + 2];
    var grayValue = grayscaleStrategy(rComponent, gComponent, bComponent);
    result.pixels[i] = grayValue;
    result.pixels[i + 1] = grayValue;
    result.pixels[i + 2] = grayValue;
  }

  return result;
};
/** Returns the given pixel to grayscale according to Phase Alternating Line */


exports.imageToGrayscale = imageToGrayscale;

var pixelToGrayscalePal = function pixelToGrayscalePal(rComponent, gComponent, bComponent) {
  return Math.round(rComponent * 0.222 + gComponent * 0.707 + bComponent * 0.071);
};

var grayscaleStrategies = {
  pixelToGrayscalePal: pixelToGrayscalePal
};
exports.grayscaleStrategies = grayscaleStrategies;